import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ClearCacheProvider, useClearCache } from "react-clear-cache";
import { Layout, Card, Button } from "antd";
import { SpinnerDotted } from "spinners-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGifts, faRefresh } from "@fortawesome/pro-regular-svg-icons";

import { GET } from "../../providers/useAxiosQuery";
import { bgColor, name, userData } from "../../providers/companyInfo";
import CheckUserPermission from "../../providers/CheckUserPermission";
import Sidemenu from "./Sidemenu";
import Header from "./Header";
import Footer from "./Footer";

export default function Private(props) {
	const {
		children,
		moduleName,
		moduleCode,
		title,
		subtitle,
		pageHeaderIcon,
		pageHeaderClass,
		pageId,
		className,
	} = props;

	const { isLatestVersion, emptyCacheStorage } = useClearCache();
	// console.log("Private props", props);

	const location = useLocation();
	const navigate = useNavigate();

	const [width, setWidth] = useState(window.innerWidth);

	const [sideMenuCollapse, setSideMenuCollapse] = useState(
		window.innerWidth <= 768 ? true : false
	);

	CheckUserPermission(moduleCode, moduleName, location);

	useEffect(() => {
		const section = document.querySelector(".private-layout");
		section.scrollIntoView({ behavior: "smooth", block: "start" });

		document.title = (moduleName ?? title).toUpperCase() + " | " + name;

		function handleResize() {
			setWidth(window.innerWidth);

			if (window.innerWidth === 768) {
				setSideMenuCollapse(true);
			}
			if (window.innerWidth > 768) {
				setSideMenuCollapse(false);
			}
		}
		window.addEventListener("resize", handleResize);

		return () => window.removeEventListener("resize", handleResize);
	}, [title, moduleName]);

	const { data: dataUserProfileInfo } = GET(
		`api/user_profile_info`,
		"user_profile_info",
		(res) => {},
		false
	);

	const { data: dataPermissions, refetch: refetchPermissions } = GET(
		`api/user_permission/${userData().id}`,
		"check_user_permission_sidemenu",
		(res) => {},
		false
	);

	useEffect(() => {
		refetchPermissions();

		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<ClearCacheProvider>
			{!isLatestVersion && (
				<div className="notification-notice">
					<div className="notification-notice-content">
						<div className="notification-notice-icon">
							<FontAwesomeIcon icon={faGifts} />
						</div>
						<div className="notification-notice-message">
							<div className="title">Updates Now Available</div>
							<div className="description">
								A new version of this Web App is ready
							</div>
							<div className="action">
								<Button
									onClick={(e) => {
										e.preventDefault();
										emptyCacheStorage();
									}}
									icon={<FontAwesomeIcon icon={faRefresh} />}
								>
									Refresh
								</Button>
							</div>
						</div>
					</div>
				</div>
			)}

			<div className="globalLoading hide">
				<SpinnerDotted thickness="100" color={bgColor} enabled={true} />
			</div>

			<Layout
				hasSider
				className={`private-layout ${className ?? ""}`}
				id={pageId ?? ""}
			>
				<Sidemenu
					location={location}
					sideMenuCollapse={sideMenuCollapse}
					setSideMenuCollapse={setSideMenuCollapse}
					width={width}
					dataPermissions={
						dataPermissions && dataPermissions.data ? dataPermissions.data : []
					}
				/>

				<Layout className={sideMenuCollapse ? "ant-layout-has-collapse" : ""}>
					<Header
						sideMenuCollapse={sideMenuCollapse}
						setSideMenuCollapse={setSideMenuCollapse}
						width={width}
						pageHeaderClass={pageHeaderClass}
						pageHeaderIcon={pageHeaderIcon}
						title={title}
						subtitle={subtitle}
						dataUserProfileInfo={
							dataUserProfileInfo && dataUserProfileInfo.data
						}
					/>

					<Layout.Content
						onClick={() => {
							if (width <= 767) {
								setSideMenuCollapse(true);
							}
						}}
					>
						<Card>{children}</Card>
					</Layout.Content>

					<Footer />
				</Layout>
			</Layout>
		</ClearCacheProvider>
	);
}
